import React, { useContext, useState } from 'react';
import { AccountContext } from '../../context';
import { useTranslation } from 'react-i18next';
import searchIcon from '../../assets/images/search-1_1.svg';
import userBlackThick from '../../assets/images/user-black-thick.svg';
import arrowUpDown from '../../assets/images/arrow-up-down_1.svg';
import chevronFirst from '../../assets/images/chevron-first_1.svg';
import chevronLeft from '../../assets/images/chevron-left-2.svg';
import chevronRight from '../../assets/images/chevron-right_1.svg';
import {
  getUsersList,
  updateUserRole,
  updateUserStatus,
} from '../../helpers/utils';
import { IBLSpinLoader } from '../../../IBLSpinLoader';
import $ from 'jquery';
import { useDebounce } from '../../helpers/useDebounce';
import InviteUser from './InviteUser';

const Users = () => {
  const { userData, handlePassWordForgotten } = useContext(AccountContext);
  const [initialUserList, setInitialUserList] = useState([]);
  const [filteredUsersList, setFilteredUsersList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [inviteUserTabFocused, setInviteUserTabFocused] = useState(false);
  const [page, setPage] = useState(1);
  const [paginationData, setPaginationData] = useState(null);

  const { t } = useTranslation('library');

  const handleJSDropdownInteraction = () => {
    $(document).on(
      'click',
      '.user-permission-dropdown.w-dropdown:not(.user-disabled)',
      function () {
        const target = $(this);
        const dropdownToggle = $(this).find('.w-dropdown-toggle');
        const dropdownList = target.find('.w-dropdown-list');
        if (dropdownToggle.attr('aria-expanded') === 'false') {
          target.css({ zIndex: '+=1' });
          dropdownToggle.addClass('w--open');
          dropdownToggle.attr('aria-expanded', 'true');
          dropdownList.addClass('w--open');
        } else {
          target.css({ zIndex: '-=1' });
          dropdownToggle.removeClass('w--open');
          dropdownToggle.attr('aria-expanded', 'false');
          dropdownList.removeClass('w--open');
        }
      }
    );
  };

  const handleUsersListSet = (data) => {
    setHasLoadedOnce(true);
    const users = Array.isArray(data?.results) ? data?.results : [];
    setInitialUserList(users);
    setFilteredUsersList(users);
    setPaginationData({
      next_page: data?.next_page,
      previous_page: data?.previous_page,
      count: data?.count,
    });
    setLoading(false);
  };

  const handleUserRoleUpdate = (user) => {
    if (user.user_id === userData.user_id) {
      return;
    }
    updateUserRole(
      {
        username: user?.username,
        org: user?.platform_org,
        role: 'org-instructor',
        active:!user?.is_admin
      },
      handleUserRoleUpdateCallBack,
      handleUserRoleUpdateErrCallback,
      user
    );
  };

  const handleUserStatusUpdate = (user, key, value) => {
    if (user.user_id === userData.user_id) {
      return;
    }
    updateUserStatus(
      {
        user_id: user.user_id,
        [key]: value,
        platform_key: user.platform_key,
      },
      handleUserStatusUpdateCallBack,
      handleUserStatusUpdateErrCallback,
      user
    );
  };

  const handleUserStatusUpdateCallBack = (userData) => {
    let updatedUsersList = [...initialUserList];
    const actualUserIndex = initialUserList.findIndex(
      (pre) => pre.user_id === userData.user_id
    );
    const updatedUserData = {
      ...userData,
      active: !userData?.active,
    };
    updatedUsersList[actualUserIndex] = updatedUserData;
    setInitialUserList([...updatedUsersList]);
    let updatedFilteredUsersList = [...filteredUsersList];
    const actualFilteredUserIndex = filteredUsersList.findIndex(
      (pre) => pre.user_id === userData.user_id
    );
    if (actualFilteredUserIndex !== -1) {
      updatedFilteredUsersList[actualFilteredUserIndex] = updatedUserData;
      setFilteredUsersList([...updatedFilteredUsersList]);
    }
  };

  const handleUserRoleUpdateCallBack = (userData) => {
    let updatedUsersList = [...initialUserList];
    const actualUserIndex = initialUserList.findIndex(
      (pre) => pre.user_id === userData.user_id
    );
    const updatedUserData = {
      ...userData,
      is_admin: !userData?.is_admin,
    };
    updatedUsersList[actualUserIndex] = updatedUserData;
    setInitialUserList([...updatedUsersList]);
    let updatedFilteredUsersList = [...filteredUsersList];
    const actualFilteredUserIndex = filteredUsersList.findIndex(
      (pre) => pre.user_id === userData.user_id
    );
    if (actualFilteredUserIndex !== -1) {
      updatedFilteredUsersList[actualFilteredUserIndex] = updatedUserData;
      setFilteredUsersList([...updatedFilteredUsersList]);
    }
  };

  const handleUserStatusUpdateErrCallback = () => {
    console.log('Something went wrong');
  };

  const handleUserRoleUpdateErrCallback = () => {
    console.log('Something went wrong');
  };

  const handleUsersListErrCallback = () => {
    setLoading(false);
    console.log('Something went wrong');
  };

  const handleSearch = () => {
    if (String(searchValue).length > 2) {
      const updatedUsersList = initialUserList.filter(
        (pre) =>
          String(pre.username)
            .toUpperCase()
            .includes(searchValue.toUpperCase()) ||
          String(pre.name).toUpperCase().includes(searchValue.toUpperCase())
      );
      setFilteredUsersList([...updatedUsersList]);
    } else {
      setFilteredUsersList([...initialUserList]);
    }
  };

  const handleInviteModalShow = () => {
    setInviteUserTabFocused(true);
  };

  useDebounce(handleJSDropdownInteraction, 200, []);

  useDebounce(
    () => {
      setFilteredUsersList([]);
      setInitialUserList([]);
      setLoading(true);
      getUsersList(
        handleUsersListSet,
        handleUsersListErrCallback,
        page,
        searchValue
      );
    },
    200,
    [page, searchValue]
  );

  return (
    <>
      <div
        data-name="users"
        className="manage-account-form-block w-form users-tab"
      >
        <form
          id="email-form-2"
          name="email-form-2"
          data-name="Email Form 2"
          method="get"
          className="manage-account-form jc-top"
          data-wf-page-id="65aec9c9e13ed74d8bfffe77"
          data-wf-element-id="9ec6b5c0-de1a-2a74-1db0-322e2506932b"
        >
          <div className="w-layout-hflex-account-ui tabs-content users-list-tab-content">
            <div className="w-layout-hflex-account-ui flex-block-22">
              <div className="w-layout-hflex-account-ui flex-block-21">
                <img
                  src={searchIcon}
                  loading="lazy"
                  alt=""
                  className="image-49 users-search-box-icon"
                />
                <input
                  value={searchValue}
                  onChange={(e) => {
                    setPage(1);
                    setSearchValue(e?.target?.value);
                  }}
                  className="text-field-4 w-input"
                  name="name-5"
                  data-name="Name 5"
                  placeholder={t('Search users')}
                  type="text"
                  id="name-5"
                />
              </div>
              <div
                onClick={handleInviteModalShow}
                data-w-id="b333349f-1241-cb0a-702c-ecfb590f8d02"
                className="button-with-icon users-settings-invite-btn"
              >
                <img
                  loading="lazy"
                  width="70"
                  src={userBlackThick}
                  alt=""
                  className="button-icon"
                />
                <div className="button-text">{t('Invite')}</div>
              </div>
            </div>
            <div
              className={`w-layout-vflex-account-ui table-container ${
                loading ? 'loading' : ''
              }`}
            >
              <div className="w-layout-hflex-account-ui table-header">
                <div className="table-block table-block-medium all-whiten-in-dark-mode">
                  <h5 className="table-title">{t('FULL NAME')}</h5>
                  <img
                    src={arrowUpDown}
                    loading="lazy"
                    alt=""
                    className="user-table-sort-icon"
                  />
                </div>
                <div className="table-block table-block-medium all-whiten-in-dark-mode">
                  <h5 className="table-title">{t('USERNAME')}</h5>
                  <img
                    src={arrowUpDown}
                    loading="lazy"
                    alt=""
                    className="user-table-sort-icon"
                  />
                </div>
                <div className="table-block table-block-medium all-whiten-in-dark-mode users-email-block">
                  <h5 className="table-title">{t('EMAIL')}</h5>
                  <img
                    src={arrowUpDown}
                    loading="lazy"
                    alt=""
                    className="user-table-sort-icon"
                  />
                </div>
                <div className="table-block table-block-medium all-whiten-in-dark-mode users-permission-block">
                  <h5 className="table-title">{t('PERMISSION')}</h5>
                  <img
                    src={arrowUpDown}
                    loading="lazy"
                    alt=""
                    className="user-table-sort-icon"
                  />
                </div>
                <div className="table-block table-block-smallest">
                  <h5 className="table-title"></h5>
                </div>
              </div>
              {loading && <IBLSpinLoader size={40} containerHeight={'100%'} />}
              {filteredUsersList.length > 0 &&
                filteredUsersList.map((user, index) => (
                  <div
                    key={`admin-list-index-${index}`}
                    className="w-layout-hflex-account-ui table-body-row greyish-bg-in-darkmode"
                  >
                    <div className="table-block table-block-medium">
                      <div className="table-text">{user.name}</div>
                    </div>
                    <div className="table-block table-block-medium">
                      <div className="table-text table-text-italic">
                        {user.username}
                      </div>
                    </div>
                    <div className="table-block table-block-medium users-email-block">
                      <a
                        href={`mailto:${String(user.email).toLowerCase()}`}
                        className="user-email-link w-inline-block"
                      >
                        <div className="table-text">
                          {String(user.email).toLowerCase()}
                        </div>
                      </a>
                    </div>
                    {/*<div className="table-block table-block-big users-last-message-block">
                    <div className="table-text">-</div>
                  </div>*/}
                    <div className="table-block table-block-medium users-permission-block">
                      <div
                        data-hover="false"
                        data-delay="0"
                        className={`user-permission-dropdown w-dropdown ${
                          user.user_id === userData.user_id
                            ? 'user-disabled'
                            : ''
                        }`}
                      >
                        <div
                          className="user-permission-dropdown-toggle w-dropdown-toggle"
                          aria-expanded={false}
                          style={{
                            cursor:
                              user.user_id === userData.user_id
                                ? 'not-allowed'
                                : 'pointer',
                          }}
                        >
                          <div className="user-permission-dropdown-toggle-icon w-icon-dropdown-toggle"></div>
                          <div className="user-permission-dropdown-toggle-text">
                            {user.is_admin ? t('Admin') : t('Student')}
                          </div>
                        </div>
                        <nav className="user-permission-dropdown-list light-black-bg-dark-mode all-whiten-in-dark-mode w-dropdown-list">
                          <a
                            href="#"
                            onClick={() => handleUserRoleUpdate(user)}
                            className="user-permission-dropdown-list-element greyish-bg-in-darkmode w-dropdown-link"
                          >
                            {user.is_admin ? t('Student') : t('Admin')}
                          </a>
                        </nav>
                      </div>
                    </div>
                    <div className="table-block table-block-small">
                      <div className="user-row-switcher-embed w-embed">
                        <label className="user-switcher">
                          <input
                            disabled={user.user_id === userData.user_id}
                            onChange={() =>
                              handleUserStatusUpdate(
                                user,
                                'active',
                                !user.active
                              )
                            }
                            type="checkbox"
                            checked={user.active}
                          />
                          <span
                            className="user-switcher-slider round"
                            style={{
                              cursor:
                                user.user_id === userData.user_id
                                  ? 'not-allowed'
                                  : 'pointer',
                            }}
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>
                ))}
              {hasLoadedOnce && !loading && filteredUsersList.length === 0 && (
                <p>{t('No record found')}</p>
              )}
            </div>
            <div className="w-layout-hflex-account-ui users-settings-pagination-block">
              <div className="w-layout-hflex-account-ui users-settings-pagination-container all-whiten-in-dark-mode">
                {!!paginationData?.previous_page &&
                  parseInt(paginationData?.previous_page) > 1 && (
                    <div
                      onClick={() => setPage(1)}
                      className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode"
                    >
                      <img
                        src={chevronFirst}
                        loading="lazy"
                        alt=""
                        className="table-pagination-btn-icon"
                      />
                    </div>
                  )}
                {!!paginationData?.previous_page && (
                  <div
                    onClick={() =>
                      setPage(parseInt(paginationData?.previous_page))
                    }
                    className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode"
                  >
                    <img
                      src={chevronLeft}
                      loading="lazy"
                      alt=""
                      className="table-pagination-btn-icon"
                    />
                  </div>
                )}
                <div className="w-layout-hflex-account-ui table-pagination-btn table-pagination-btn-active">
                  <h5 className="table-pagination-page-number primary-color-in-dark-mode">
                    {page}
                  </h5>
                </div>
                {!!paginationData?.next_page && (
                  <div
                    onClick={() => setPage(parseInt(paginationData?.next_page))}
                    className="w-layout-hflex-account-ui table-pagination-btn greyish-bg-in-darkmode"
                  >
                    <img
                      src={chevronRight}
                      loading="lazy"
                      alt=""
                      className="table-pagination-btn-icon"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
        <div className="w-form-done">
          <div>{t('Thank you! Your submission has been received!')}</div>
        </div>
        <div className="w-form-fail">
          <div>
            {t('Oops! Something went wrong while submitting the form.')}
          </div>
        </div>
      </div>
      {inviteUserTabFocused && (
        <InviteUser setFocused={() => setInviteUserTabFocused(false)} />
      )}
    </>
  );
};

export default Users;
